import React from 'react';

import ImageStats from 'marketing-website/components/modules/ContentBlocks/ImageStats';

import styles from './style/stats.module.css';

export default function Stats() {
  return (
    <div className={styles.container}>
      <div className={styles.centered}>
        <div className={styles.whitePiece} />
      </div>
      <ImageStats align="center" name="security" />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/security/Stats.js